import React from "react";
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { withStyles } from '@mui/styles';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import DashboardTemplate from "../components/templates/DashboardTemplate";
import MixpanelOnload from "../components/MixpanelOnload";

//import PaymentIcon from '@mui/icons-material/PaymentIcon';
import HowToInviteImage from '../img/screenshots/how_to_invite.png';
import HowToAddLanguage from '../img/screenshots/add_language.png';
import HowToSelectButton from '../img/screenshots/setting.png';
import KiaraLogo from '../img/kiara_logo_icon_red.png';
import Step1Logo from '../img/steps/step1.png';
import Step2Logo from '../img/steps/step2.png';
//const moment = require('moment');

const useStyles = theme => ({
    '@global': {
    },
    paper: {
        padding: '8px',
    }
});

const SpacedCardContent = styled(CardContent)(({ theme }) => ({
    '& > *:not(:last-child)': {
        marginBottom: theme.spacing(3),
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}));

class SetupFinish extends React.Component {

    constructor() {
        super();
        this.state = {
            productName: "Loading",
            hasPlan: false,
            isTrial: true,
            planType: 21,
            productId: 5,
            unitCount: 10,
            setPlan: true,
        };
        this.getAccount = this.getAccount.bind(this);
    }

    componentDidMount() {
        this.getAccount();
    }

    getAccount() {
        fetch('/api/account')
            .then(res => res.json())
            .then(data => {
                // TODO set flags
                console.log(data);
                if (data.planType) {
                    this.setState({ planType: data.planType });
                    this.setState({ productId: data.productId });
                    this.setState({ productName: data.productName });
                }
                else {
                    this.setState({ hasPlan: false });
                    this.setState({ setPlan: true });
                    this.setState({ isTrial: true });
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({ hasPlan: false });
                this.setState({ setPlan: true });
                this.setState({ isTrial: true });
            })
    }

    prependItems = () => {
        return <div>
        </div>
    }

    appendItems = () => {
        const { productName } = this.state.productName;
        if (productName === 'Enterprise_Monthly' || productName === 'Enterprise_Yearly') {
            return (
                <Grid container direction="column" spacing={8} alignItems="center" sx={{ marginTop: '50px' }}>
                    <Grid item md={12}>
                        <Typography variant="h4" component="p">
                            Thank you for choosing Enterprise Plan
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                            <Typography variant="h6" component="p" sx={{ marginBottom: '20px' }}>
                                Let's customize your plan
                            </Typography>
                            <Typography variant="body1" sx={{ marginBottom: '30px' }}>
                                Please fill out the form below and our team will contact you shortly.
                            </Typography>
                            <Button
                                variant="contained"
                                href="https://form.typeform.com/to/TGul9a20"
                                target="_blank"
                                sx={{
                                    backgroundColor: '#FF2B01',
                                    '&:hover': {
                                        backgroundColor: '#cc2201',
                                    },
                                    marginBottom: '20px'
                                }}
                            >
                                Contact Sales Team
                            </Button>
                        </Paper>
                    </Grid>
                </Grid>
            )
        } else {
            return (
                <Grid container direction="column" spacing={8} alignItems="center" sx={{ marginTop: '50px' }}>
                    <Typography variant="h4" component="p">
                        Thank you for your registration.
                    </Typography>
                    <p>Your free trial will be expired in 14 days.</p>
                    <img src={KiaraLogo} alt="kiara logo" style={{ 'width': '250px' }} />

                    <Grid item md={12}>
                        <Typography variant="h4" component="p">
                            How to setup
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={8} sx={{ marginBottom: '40px' }}>
                        <img src={Step1Logo} alt="step1 logo" style={{ 'width': '100px' }} sx={{ marginBottom: '20px' }} />
                        <p>Say "@Kiara" to the channel you want to add</p>
                        <Box sx={{ width: '100%', maxWidth: '500px', margin: '20px 0 auto' }}>
                            <img src={HowToInviteImage} alt="how to invite on slack" style={{ 'width': '100%' }} />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={8} sx={{ marginBottom: '40px' }}>
                        <img src={Step2Logo} alt="step2 logo" style={{ 'width': '100px' }} sx={{ marginBottom: '20px' }} />
                        <p>Press "Add" button and select language</p>
                        <Box sx={{ width: '100%', maxWidth: '500px', margin: '0 auto' }}>
                            <img src={HowToSelectButton} alt="how to select button" style={{ 'width': '100%', height: 'auto', marginBottom: '20px' }} /><br />
                            <img src={HowToAddLanguage} alt="how to add language" style={{ 'width': '100%', height: 'auto' }} />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Typography variant="h6" component="p" sx={{ marginBottom: '20px' }}>
                            Setup is Completed!
                        </Typography>
                        <p> Need support? Please check out our <a href="https://www.getkiara.com/help/category/faq">FAQ</a>.<br />
                            For more information, talk to us by chat, <a href="https://www.getkiara.com/contact">form</a> or to hello@kiara.team</p>
                    </Grid>
                </Grid>
            )
        }
    }

    render() {
        // TODO change trial finish date
        return (
            <DashboardTemplate maxWidth="xl" prependItems={this.prependItems()} appendItems={this.appendItems()}>
                <div>
                    <CardContent align="center">
                        <SpacedCardContent>

                        </SpacedCardContent>
                    </CardContent>
                    <MixpanelOnload message="kiara-app.com/setup-finish" />
                </div>
            </DashboardTemplate>
        )
    }
}
export default withStyles(useStyles)(SetupFinish);
